import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { Map } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const googleMapsDirectionsUrl = "https://www.google.com/maps/dir//";

const useStyles = makeStyles(theme => ({
  buttonText: {
    paddingLeft: theme.spacing(1.5)
  },
  button: {
    fontWeight: 500,
    fontSize: "0.9375rem"
  }
}));

function GetDirectionsButton(props) {
  const { location, ...buttonProps } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  /**
   * Creates the URL for Google Maps directions and opens it in a new tab
   */
  const openDirections = () => {
    const locationUrl =
      googleMapsDirectionsUrl +
      encodeURI(
        [
          location.address1,
          location.address2,
          location.city,
          location.state,
          location.zip
        ].join(" ")
      );
    window.open(locationUrl);
  };

  return (
    <Button
      variant="text"
      color="primary"
      {...buttonProps}
      className={classes.button}
      onClick={openDirections}
    >
      <Map size="small" color="primary" />
      <span className={classes.buttonText}>{t("getDirections")}</span>
    </Button>
  );
}

export default GetDirectionsButton;

GetDirectionsButton.propTypes = {
  location: PropTypes.shape({
    name: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number
  })
};
